import { tableStyles } from 'css/tableStyles';
import React from 'react';
import DataTableNPM from 'react-data-table-component';
import styles from './index.module.scss';

const getLoaderColumns = (columns) => {
  return columns.map((column)=>{
    return {
      name: column?.name,
      cell: () => (
        <div className={styles['loader-cell']}>
          <span className={styles['skeleton-loader']}></span>   
        </div>
      ),
    };
  });
};

const getLoadingData = (loadingRowsCount = 5) => {
  return Array.from({ length: loadingRowsCount }, (_, i) => i + 1)?.map(()=>{
    return {};
  });
};

const DataTableLoader = (props) => {
  const { loadingRowsCount = 5 } = props;
  const loaderColumns = getLoaderColumns(props?.columns);
  return (
    <div className={styles['loader-container']}>
      <DataTableNPM
        noHeader={true} 
        columns={loaderColumns} 
        data={getLoadingData(loadingRowsCount)} 
        customStyles={tableStyles}
        onChangePage={props?.onChangePage}
      />
    </div>
  );
  
};

export default DataTableLoader;